<template>
  <div>
    <ScoreJianluList
      v-if="jianluShowType === 1"
      :row="row.start"
      :list="row.list"
      :saiqu="row.saiqu"
      :broadcast="row.jianlu_broadcast"
      :start-id="$route.query.start_id"
    />
    <ScoreJianluLive
      v-else
      :row="row.start"
      :saiqu="row.saiqu"
    />
  </div>
</template>

<script>
import {Toast} from "vant";
import ScoreJianluList from "@/components/score/ScoreJianluList.vue";
import ScoreJianluLive from "@/components/score/ScoreJianluLive.vue";
export default {
  name: "JianluShow",
  data: function () {
    return {
      row: {
        start: {},
        saiqu: {},
        list: [],
        jianlu_broadcast: null,
      }
    }
  },
  components: {
    ScoreJianluList,
    ScoreJianluLive,
  },
  computed: {
    jianluShowType() {
      const t = Number(this.row.start && this.row.start.jianlu_show_type)
      return t === 2 ? 2 : 1
    },
  },
  filters: {},
  mounted() {
    let that = this;
    document.title="数据展示"
    that.fetch()
    that.timer = setInterval(function () {
      that.fetch()
    }, 2000)
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.post('/api/dscore/scoreStartSubjectList', {
        saiqu: that.$route.query.saiqu,
        start_id: that.$route.query.start_id,
      }, (res) => {
        that.row = res.data;
      }, (res) => { 
          Toast(res.msg)
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// JianluShow.vue?21dcc49b